import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "./LandingPage.module.css";
import { Box, Card, Typography, useMediaQuery } from "@mui/material";
import {
  AboutUsLine,
  GmailLogo,
  InstagramLogo,
  WhatasappIcon,
} from "../../svgImage";
import defxLogo from "../../assets/DefxLogo.png";

const FooterComponent = () => {
  const handleGmailCardClick = () => {
    const email = "shreeprasadam135@gmail.com";
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;
    window.open(gmailUrl, "_blank");
  };
  const isMobile = useMediaQuery("(max-width:468px)");

  const onDirectToDefx = () => {
    window.open("https://defx.in/", "_blank");
  };
  const onDirectOrder = () => {
    window.open("https://www.whatsapp.com/catalog/918980593216/?app_absent=0");
  };
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        background: "#FCF3E8",
        padding: "32px 0",
      }}
    >
      {/* Inner Container with maxWidth + padding */}
      <Box
        sx={{
          maxWidth: "940px",
          margin: "auto",
          px: isMobile ? 2 : 0, // 16px on mobile
        }}
      >
        {/* Logo + Menus */}
        <Grid size={12} display="flex" justifyContent={"center"}>
          <img src="/prasadamFooter.svg" height={120} width={320} alt="Shree" />
        </Grid>

        <Grid container justifyContent="space-between" mt="64px">
          {/* Left Menu */}
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              gap: 4,
            }}
          >
            <a
              href="#mustTry"
              style={{ textDecoration: "none", color: "inherit" }}
              className={styles.footerLink}
            >
              Desserts
            </a>
            <a
              href="#umami"
              style={{ textDecoration: "none", color: "inherit" }}
              className={styles.footerLink}
            >
              Umami
            </a>
            <a
              href="#gifting"
              style={{ textDecoration: "none", color: "inherit" }}
              className={styles.footerLink}
            >
              Gifting
            </a>
          </Grid>

          {/* Right Menu */}
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              gap: 4,
            }}
          >
            <a
              href="#home"
              style={{ textDecoration: "none", color: "inherit" }}
              className={styles.footerLink}
            >
              Home
            </a>
            <a
              href="#contact"
              style={{ textDecoration: "none", color: "inherit" }}
              className={styles.footerLink}
            >
              Contact us
            </a>

            <Typography
              className={styles.footerLink}
              onClick={onDirectOrder}
              sx={{ cursor: "pointer" }}
            >
              Order online
            </Typography>
          </Grid>
        </Grid>

        {/* Divider */}
        <Box
          sx={{
            position: "relative",
            left: "50%",
            marginLeft: "-50vw",
            width: "100vw",
            height: "1px",
            background: "#D2A67966",
            mt: 4,
            mb: 4,
          }}
        />

        {/* Bottom Row */}
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography className={styles.footerPolicy}>
              ©Copyright Shree Prasadam
            </Typography>
          </Grid>

          <Grid item>
            <Typography className={styles.footerPolicy}>
              Google – ⭐ 4.9
            </Typography>
          </Grid>

          <Grid item onClick={onDirectToDefx} sx={{ cursor: "pointer" }}>
            <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
              <Typography className={styles.footerPolicy}>
                Crafted by
              </Typography>
              <img src={defxLogo} width={60} height={20} alt="DefX" />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default FooterComponent;
